<template>
    <a-modal
      title="Limpiar historico"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-select mode="tags" style="width: 100%" :token-separators="[',']" v-model="value">
        <a-select-option v-for="i in list_status" :key="i">
          {{i}}
        </a-select-option>
      </a-select>
    </a-modal>
</template>
<script>
  const LIST_STATUS = [
    'FINALIZADO',
    'FALLIDO',
    'PROGRAMADO',
    'EN EJECUCION'
  ]

  export default {
    data () {
      return {
        list_status: LIST_STATUS,
        visible: false,
        confirmLoading: false,
        value: []
      }
    },
    methods: {
      showModal () {
        this.visible = true
      },
      handleOk (e) {
        this.confirmLoading = true
        this.$emit('lstatus', this.value)
        this.confirmLoading = false
        this.visible = false
        this.value = []
      },
      handleCancel (e) {
        this.visible = false
        this.value = []
      }
    }
  }
</script>>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GReport/ListLimpiarHistorial.vue